import { BatchSuggestionSchema } from "@redotech/redo-model/fulfillments/batch-suggestion";
import { AdvancedFilterInputSchema } from "@redotech/redo-model/outbound-labels/fulfillment-group-summary-input";
import * as z from "zod/v4";

export const getBatchSuggestions = {
  name: "getBatchSuggestions" as const,
  input: AdvancedFilterInputSchema,
  output: z.object({ suggestions: z.array(BatchSuggestionSchema) }),
};
